import DataTable from "../../components/common/DataTable";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { notifications } from "@mantine/notifications";
import { AnalyticsPageLayout, ChartCard, TOOLTIP_STYLE, chartProps } from "./AnalyticsLayout";
import { Tv } from "lucide-react";

const contentPerformanceData = [
  { name: "Action", views: 125680, revenue: 15420 },
  { name: "Drama", views: 98450, revenue: 12340 },
  { name: "Comedy", views: 87230, revenue: 10980 },
  { name: "Horror", views: 65430, revenue: 8230 },
  { name: "Romance", views: 54320, revenue: 6850 },
];

const contentAnalytics = [
  { key: "1", title: "The Last Kingdom", type: "Series", views: 425680, uniqueViewers: 385200, watchTime: 2145680, completionRate: "78%", avgRating: 4.5 },
  { key: "2", title: "Avatar 2", type: "Movie", views: 385420, uniqueViewers: 345890, watchTime: 1925640, completionRate: "85%", avgRating: 4.7 },
  { key: "3", title: "Wednesday", type: "Series", views: 325680, uniqueViewers: 298450, watchTime: 1856450, completionRate: "72%", avgRating: 4.3 },
  { key: "4", title: "Oppenheimer", type: "Movie", views: 298560, uniqueViewers: 267890, watchTime: 1492800, completionRate: "88%", avgRating: 4.8 },
];

const contentColumns = [
  { title: "Content Title", dataIndex: "title", key: "title", width: 200 },
  { title: "Type", dataIndex: "type", key: "type" },
  { title: "Views", dataIndex: "views", key: "views", render: (t) => t.toLocaleString() },
  { title: "Unique Viewers", dataIndex: "uniqueViewers", key: "uniqueViewers", render: (t) => t.toLocaleString() },
  { title: "Watch Time (hrs)", dataIndex: "watchTime", key: "watchTime", render: (t) => (t / 3600).toFixed(2) },
  { title: "Completion %", dataIndex: "completionRate", key: "completionRate" },
  { title: "Avg Rating", dataIndex: "avgRating", key: "avgRating" },
];

const ContentAnalyticsPage = () => {
  const handleExport = (format) => {
    notifications.show({ message: `Exporting as ${format.toUpperCase()}...`, color: "green" });
  };

  return (
    <AnalyticsPageLayout
      icon={Tv}
      title="Content Analytics"
      subtitle="Performance metrics for all content"
      onExport={handleExport}
    >
      <div className="mb-8">
      <ChartCard title="Content Performance by Genre">
        <div style={{ height: 400 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={contentPerformanceData}>
              <CartesianGrid {...chartProps.grid} />
              <XAxis dataKey="name" {...chartProps.axis} />
              <YAxis yAxisId="left" {...chartProps.axis} />
              <YAxis yAxisId="right" orientation="right" {...chartProps.axis} />
              <RechartsTooltip contentStyle={TOOLTIP_STYLE} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar yAxisId="left" dataKey="views" fill="#3b82f6" name="Views" />
              <Bar yAxisId="right" dataKey="revenue" fill="#10b981" name="Revenue" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </ChartCard>
      </div>

      <ChartCard title="Top Performing Content">
        <DataTable dataSource={contentAnalytics} columns={contentColumns} pagination={{ pageSize: 10 }} scroll={{ x: 1000 }} rowKey="key" />
      </ChartCard>
    </AnalyticsPageLayout>
  );
};

export default ContentAnalyticsPage;
